import React from 'react';

import { BrowsePageOutput } from 'js/model/rainbow/browse-page/BrowsePageOutput';
import { CmsBrowsePage } from 'js/model/cms/cms-browse-page';
import { Context } from 'js/components/LocaleWrapper';
import { TrackBrowsePageAndSessionView } from 'js/hooks/useTrackPageAndSessionView';
import { AppsFlyerScript } from 'js/components/AppsFlyerScript/AppsFlyerScript';
import { CmsPageTitle } from './BrowseTitle';
import { BrowsePageInner } from './BrowsePageInner';
import { BrowseData } from './BrowseData';
import styles from './BrowsePage.module.css';

export class BrowsePage extends React.Component<unknown> {
  static contextType = Context;

  declare context: React.ContextType<typeof Context>;

  private renderView = (
    browsePageOutput: BrowsePageOutput,
    loading: boolean
  ): React.ReactNode => {
    const cms = this.context.pageData.cms as CmsBrowsePage & CmsPageTitle;
    const treatmentTypeId =
      browsePageOutput.specification.treatmentCategoryGroup?.id.toString();
    const hasPopularTreatments =
      treatmentTypeId && !browsePageOutput.specification.treatmentCategories
        ? cms.page.browse.filters['popular-treatments'][treatmentTypeId]
        : [];

    return (
      <TrackBrowsePageAndSessionView
        treatmentType={treatmentTypeId}
        treatment={browsePageOutput.specification.treatmentCategories
          ?.map((treatment) => treatment.id)
          .join(', ')}
        hasPopularTreatments={hasPopularTreatments?.length > 0}
      >
        <BrowsePageInner
          browsePageOutput={browsePageOutput}
          loading={loading}
          cms={cms}
          featureFlags={this.context.pageData.featureFlags || ''}
        />
        {browsePageOutput.aggregations.brands &&
          browsePageOutput.aggregations.brands.length > 0 && (
            <div className={styles.brandLinks} data-cy="brand-links">
              <p>{cms.page.browse.filters.brands.brands}</p>
              <ul>
                {browsePageOutput.aggregations.brands.map((brand) => (
                  <li key={brand.id}>
                    <a href={`https://${brand.browsePageUri}`}>{brand.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          )}
      </TrackBrowsePageAndSessionView>
    );
  };

  public render(): React.ReactNode {
    const browsePage = this.context.pageData.browse as BrowsePageOutput;
    return (
      <>
        <AppsFlyerScript />
        <BrowseData
          initialBrowsePageOutput={browsePage}
          renderPage={this.renderView}
        />
      </>
    );
  }
}

BrowsePage.contextType = Context;
